import "./App.css";
import Home from "./Home/Home";
import { HashRouter, Routes, Route } from "react-router-dom";
import Resume from "./Resume/Resume";
import Projects from "./Project/Projects"
import ProjectList from "./Project/ProjectList";

function App() {

  return (
    <>
    <HashRouter>
      <Routes>
        <Route path="" index element={<Home />}/>
        <Route path="resume" element={<Resume />}/>
        <Route path="projects" element={<Projects />}/>
      </Routes>
    </HashRouter>
{/* <ProjectList />
<Resume /> */}
    </>
  );
}

export default App;
